import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  const goToContacto = () => {
    const contacto = document.getElementById('contactanos');
    if (contacto) {
      contacto.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-wrap">
        <div className="footer-brand">
          <p className="footer-copy">
            Soluciones profesionales en limpieza para hogar, comercio e industria.
          </p>
        </div>

        <div className="footer-col">
          <h4>Navegación</h4>
          <ul className="footer-links">
            <li><Link to="/">Inicio</Link></li>
            <li><Link to="/tienda">Tienda</Link></li>
            <li><button type="button" className="footer-link-button" onClick={goToContacto}>Contacto</button></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4>Atención</h4>
          <ul className="footer-links">
            <li><a href="tel:+526672851980">Tel. (667) 285 1980</a></li>
            <li><a href="https://wa.me/526671743222" target="_blank" rel="noopener noreferrer">WhatsApp</a></li>
            <li><a href="mailto:cleanzone.ventas1@gmail.com">cleanzone.ventas1@gmail.com</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {year} CleanZone. Todos los derechos reservados.</p>
      </div>
    </footer>
  );
};

export default Footer;
